export default __webpack_public_path__ + "static/media/pic31.4c58a657.jpg";